/**
 * Product feature diagram — sections/product-feature-diagram.liquid
 * (Asana 1219243817614415).
 *
 * The numbered legend stands alone with JS off; this only adds the shortcut
 * from a numbered marker on the photo to its legend row. Markers are real
 * <button>s, so click covers mouse, touch, Enter and Space.
 *
 * Every lookup is scoped to its own [data-feature-diagram] root, so two
 * diagrams on one page never clear or set each other's state. Markers use
 * data-feature-hotspot (not data-awg-hotspot) so assets/awg-belowfold.js,
 * which still runs on some of the same pages, never binds them.
 */
(function () {
  'use strict';

  var READY_ATTR = 'data-pfd-ready';

  function prefersReducedMotion() {
    return Boolean(
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function activate(root, hotspot) {
    var targetId = hotspot.getAttribute('aria-controls');
    var target = targetId ? document.getElementById(targetId) : null;
    if (!target || !root.contains(target)) return;

    Array.prototype.forEach.call(root.querySelectorAll('[data-feature-hotspot]'), function (other) {
      other.removeAttribute('aria-current');
    });
    Array.prototype.forEach.call(root.querySelectorAll('.callout.is-active'), function (row) {
      row.classList.remove('is-active');
    });

    hotspot.setAttribute('aria-current', 'true');
    target.classList.add('is-active');

    target.scrollIntoView({
      block: 'nearest',
      behavior: prefersReducedMotion() ? 'auto' : 'smooth'
    });
  }

  function initRoot(root) {
    if (root.hasAttribute(READY_ATTR)) return;
    root.setAttribute(READY_ATTR, '');

    root.addEventListener('click', function (event) {
      var hotspot = event.target.closest('[data-feature-hotspot]');
      if (!hotspot || !root.contains(hotspot)) return;
      activate(root, hotspot);
    });
  }

  function initWithin(scope) {
    if (!scope || !scope.querySelectorAll) return;
    if (scope.matches && scope.matches('[data-feature-diagram]')) initRoot(scope);
    Array.prototype.forEach.call(scope.querySelectorAll('[data-feature-diagram]'), initRoot);
  }

  function boot() {
    initWithin(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme Editor: a re-rendered section arrives as new markup; bind it. The
  // old root and its listener are discarded with the removed DOM on unload.
  document.addEventListener('shopify:section:load', function (event) {
    initWithin(event.target);
  });
})();
